import { Grid, Select, BodyText, OpenLinkInNewTab, Button, FlexRow, Spinner, ISelectOption } from 'ui-toolkit';
import React from 'react';
import { useState } from 'react';
import { clientUrls } from '../../ui-toolkit/rest/ClientUrlFactory';

interface IAddLender {
  listOfLenders: Array<ISelectOption<string>>;
  onSelectLender: (value: ISelectOption<string> | null) => void;
  refreshListOfLenders: () => void;
  loading: boolean;
}

export const AddLender: React.FC<IAddLender> = ({ listOfLenders, onSelectLender, refreshListOfLenders, loading }) => {
  const [value, setValue] = useState<ISelectOption<string> | null>(null);
  const [openNextTab, setOpenNextTab] = useState(false);

  const onInputChange = (newLender: ISelectOption<string> | null) => {
    setValue(newLender);
    onSelectLender(newLender);
  };

  const toggleOpenNextTab = () => {
    setOpenNextTab(!openNextTab);
  };
  const onRefreshLender = async () => {
    await refreshListOfLenders();
    toggleOpenNextTab();
  };

  return (
    <Grid templateColumns={'1fr min-content 1fr'} alignItems={'center'}>
      <Select
        value={value}
        options={listOfLenders}
        onChange={onInputChange}
        label={`Existing Lender`}
        placeholder={`Select Lender`}
        autoFocus={true}
      />
      <BodyText>Or</BodyText>
      <FlexRow>
        {loading ? (
          <Spinner />
        ) : openNextTab ? (
          <Button intent={'ghost'} isInline onClick={onRefreshLender}>
            Refresh list of lenders
          </Button>
        ) : (
          <OpenLinkInNewTab
            href={clientUrls.urlFor.lendersIndex()}
            onClick={toggleOpenNextTab}
            text={'Add a New Lender'}
          />
        )}
      </FlexRow>
    </Grid>
  );
};
